import { render, staticRenderFns } from "./DocList.vue?vue&type=template&id=082f0170&scoped=true&"
import script from "./DocList.vue?vue&type=script&lang=js&"
export * from "./DocList.vue?vue&type=script&lang=js&"
import style0 from "./DocList.vue?vue&type=style&index=0&id=082f0170&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082f0170",
  null
  
)

export default component.exports